export const INTERACTION_ID = Symbol('__INTERACTION_ID__');
